import { createSlice } from "@reduxjs/toolkit";
import { fetchCostTypesAndCategories, fetchBudgetsByPhase } from "./thunk";

const initialState = {
  costTypes: [],
  categories: [],
  subCategories: [],
  budgets: [],
  loading: false,
  budgetsLoading: false,
  error: null,
};

const vendorInvoiceConfigSlice = createSlice({
  name: "vendorInvoiceConfig",
  initialState,
  reducers: {
    clearBudgets(state) {
      state.budgets = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCostTypesAndCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCostTypesAndCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.costTypes = action.payload.costTypes;
        state.categories = action.payload.categories;
        state.subCategories = action.payload.subCategories;
      })
      .addCase(fetchCostTypesAndCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchBudgetsByPhase.pending, (state) => {
        state.budgetsLoading = true;
      })
      .addCase(fetchBudgetsByPhase.fulfilled, (state, action) => {
        state.budgetsLoading = false;
        state.budgets = action.payload;
      })
      .addCase(fetchBudgetsByPhase.rejected, (state) => {
        state.budgetsLoading = false;
      });
  },
});

export const { clearBudgets } = vendorInvoiceConfigSlice.actions;
export default vendorInvoiceConfigSlice.reducer;
